export default __webpack_public_path__ + "static/124-05110b2fbccafbbf6e688a4505bff89f.jpg";